import React, { useEffect, useState } from 'react'
import { useHistory, useParams } from 'react-router-dom' // Make sure it's from react-router-dom
import { cleanHeaderName, REFRESH_TOKEN_HEADER, TOKEN_HEADER } from 'utils'
import { varifyUser } from 'store/queries/supabse/register'
import { AuthProvider } from '../auth'
import { EAuthSectionTypes } from 'models'

const Varify = () => {
	const { token } = useParams<{ token: string }>() // Correctly extract token
	const [loading, setLoading] = useState(true)
	const [error, setError] = useState<string | null>(null)
	// const [data, setData] = useState(null)

	const router = useHistory()
	useEffect(() => {
		if (!token) {
			setError('No token provided.')
			setLoading(false)
			return
		}

		const verify = async () => {
			try {
				await varifyUser({ token }).then(res => {
					if (res.session) {
						localStorage.setItem(
							cleanHeaderName(TOKEN_HEADER),
							res.session.access_token,
						)
						localStorage.setItem(
							cleanHeaderName(REFRESH_TOKEN_HEADER),
							res.session.refresh_token,
						)
						router.push('/')
					}
				})
			} catch (err) {
				setError((err as Error).message)
			} finally {
				setLoading(false)
			}
		}

		verify()
	}, [token, router])
	if (localStorage.getItem(cleanHeaderName(TOKEN_HEADER))) {
		router.push('/')
	}
	if (loading) return <div>Loading...</div>
	if (error) return <div>Error: {error}</div>

	return (
		<div>
			<h1>Verification Successful</h1>
			<p>Welcome! Your account has been verified.</p>
		</div>
	)
}

export default ({ ...props }) => {
	const { section }: { section: EAuthSectionTypes } = props.match.params
	return (
		<AuthProvider initialSection={EAuthSectionTypes[section]}>
			<Varify {...props} />
		</AuthProvider>
	)
}
